<template>
  <el-dialog
    :visible.sync="showModal"
    :center="true"
    :append-to-body="true"
    width="32%"
    class="premium-content-modal"
    data-test="modal-premiumcontent"
    @closed="emitEvent"
  >
    <el-row>
      <el-col
        :span="24"
        justify="center"
        align="center"
      >
        <h3>This show is a <br> Luminary Original</h3>
        <p>Go Premium to listen to this episode.</p>
        <router-link
          to="/premium"
          class="el-button el-button--primary"> Learn More </router-link>
        <span>{{ formattedLocalPricingWithTax }}</span>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: 'PremiumContentModal',
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: this.show_modal,
    };
  },
  watch: {
    showModal: () => this.show_modal,
  },
  methods: {
    emitEvent() {
      this.$emit('modalClosed');
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.premium-content-modal {
  border-radius: 8px;
  .el-dialog {
    .el-dialog__body {
      h3 {
        font-size: 28px;
        margin: 0 0;
        line-height: 32px;
        color: $black;
        font-weight: 500;
      }
      p {
        margin: 20px 0;
        font-weight: 400;
        font-size: 16px;
      }
      .el-button {
        padding: 1.2rem 2.2rem;
        font-family: Favorit;
      }
      span {
        font-size: 14px;
        display: block;
        margin: 8px 0 20px 0;
        color: $gray;
      }
      a:not(.el-button) {
        color: $black;
        display: block;
        font-size: 16px;
        padding-bottom: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PremiumContentModal.vue